import React, { useState } from "react";
import Table from "components/Table";
import Filter from "components/Filter";
import {
  BLOCK_FETCH_URL,
  DIVISION_FETCH_URL,
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  ROLES_URL,
  ZONE_FETCH_URL,
} from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";


const model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "role", label: "Role", type: "string" },
  { id: "id_number", label: "ID Number", type: "string" },
  { id: "designation", label: "Designation", type: "string" },
  { id: "estate_name", label: "Estate Name", type: "string" },
  { id: "approval_status", label: "Status", type: "string" },
  { id: "created_at", label: "Created Date", type: "string" },
  { id: "created_by", label: "Created By", type: "string" },
  {
    id: "approved_rejected_date",
    label: "Approved/Rejected Date",
    type: "string",
  },
  { id: "approved_rejected_by", label: "Approved/Rejected By", type: "string" },
];
const pageNumberDropdown = true;

const urls = {
  proxyURL: "new-user/mixed-users/",
  exportURL: "new-user/mixed-users/export/",
};
const getCompanyValues = (e, setDisableZone) => {
  if (!e || e.length === 0) {
    setDisableZone(true);
  }
  else {
    setDisableZone(false);
  }

};
const getZoneValues = (e,setDisableRegion) => {
  if (!e || e.length === 0) {
    setDisableRegion(true);
  }
  else {
    setDisableRegion(false);
  }
  
};
const getRegionValues = (e,setDisableEstate) => {
  if (!e || e.length === 0) {
    setDisableEstate(true);
  }
  else {
    setDisableEstate(false);
  }
  
};

const getEstateValues = (e,setDisableDivision) => {
  if (!e || e.length === 0) {
    setDisableDivision(true);
  }
  else {
    setDisableDivision(false);
  }
  
};
const getDivisonValues = (e,setDisableBlock) => {
  if (!e || e.length === 0) {
    setDisableBlock(true);
  }
  else {
    setDisableBlock(false);
  }
  
};

const ApprovedAndRejectedUsers = () => {
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableDivision, setDisableDivision] = useState(true);
  const [disableBlock, setDisableBlock] = useState(true);
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [disableZone, setDisableZone] = useState(true);

  
  const filterFields = [
    {
      type: "input",
      label: "Employee ID",
      name: "employee_id",
    },
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "input",
      label: "Mobile Number",
      name: "mobile_number",
    },
    {
      type: "input",
      label: "ID Number",
      name: "id_number",
    },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,

      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL,

      paginated: true,
      disabled:disableEstate,
      getValue: (e) => getEstateValues(e, setDisableDivision),

      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "division",
      label: "Division",
      proxyUrl: DIVISION_FETCH_URL,
      paginated: true,
      disabled:disableDivision,
      getValue: (e) => getDivisonValues(e, setDisableBlock),

      optionsDependsOn: "estate",
    },
    {
      type: "reactselect",
      name: "block",
      label: "Block",
      proxyUrl: BLOCK_FETCH_URL,
      paginated: true,
      disabled:disableBlock,

      optionsDependsOn: "division",
    },
    {
      type: "reactselect",
      name: "role",
      label: "Role",
      proxyUrl: ROLES_URL,
      paginated: false,
      isPaginationEnabled: false,
        },
    {
      type: "reactselect",
      name: "approval_status",
      label: "Status",
      outerOptions: [
        { id: "Approved", name: "Approved" },
        { id: "Rejected", name: "Rejected" },
      ],
    },
  ];

  const filterInitialValues = {
    employee_id: "",
    name: "",
    mobile_number: "",
    id_number: "",
    zone: "",
    region: "",
    estate: "",
    division: "",
    role: "",
    block: "",
    status: "",
  };

  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);

  };
  const clearFilter =()=>{
    filterInitialValues.status = null
    location.reload();
   }

  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={clearFilter}


        
      />
            {filtersApplied ? (

      <Table
        proxyURL={urls.proxyURL}
        model={model}
        excelExport={{ fileName: "approved-rejected" }}
        filterValues={filterValues}
        noAddButton
        noFilter
        pageNumberDropdown={pageNumberDropdown}
        linkUrlName="/edit/"
      />
      ) : (
        <Table
        proxyURL={null}
        model={model}
        excelExport={{ fileName: "approved-rejected" }}
        filterValues={filterValues}
        noAddButton
        noFilter
        pageNumberDropdown={pageNumberDropdown}
        linkUrlName="/edit/"
      />
      )}

    </div>
  );
};

export default ApprovedAndRejectedUsers;
